import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {CategoriaDictamen} from "../../../../domain/categoria-dictamen";
import {GlobalAppService} from "../../../../../core/commons/global-app.service";
import {CategoriaDictamenService} from "../../../../service/categoria-dictamen.service";
import {MessageSeverity} from "app/core/commons/message-severity";

@Component({
    selector: 'dictamen-categoria-form',
    templateUrl: './categoria-form.component.html',
    styleUrls: ['./categoria-form.component.scss'],
    providers: [ CategoriaDictamenService ]
})
export class CategoriaFormComponent implements OnInit {

    @Input() display: boolean = false;

    @Output() displayChange: EventEmitter<boolean> = new EventEmitter();

    @Input() update: boolean = false;

    @Input() categoria: CategoriaDictamen = new CategoriaDictamen();

    @Output() onChange: EventEmitter<CategoriaDictamen> = new EventEmitter();

    @Input() title: string = "";

    isInvalid : boolean = false;

    error : string = "El campo es invalido";

    constructor(private messageService: GlobalAppService,
                private categoriaService: CategoriaDictamenService) {
    }

    ngOnInit() {
    }

    public saveCategoria(){
        if (this.validate()){
            if (this.update)
                this.categoriaService.update(this.categoria).subscribe(
                    c => {
                        this.messageService.sendMsg(MessageSeverity.SUCCESS, "Creado",
                            "La categoria se modifico correctamente.");
                        this.close();
                        this.onChange.emit(c);
                    },
                    error => {
                        this.messageService.sendMsg(
                            MessageSeverity.ERROR,
                            "Error:",
                            "No se a podido modificar la categoria."
                        )
                    }
                );
            else
                this.categoriaService.create(this.categoria).subscribe(
                    c => {
                        this.messageService.sendMsg(MessageSeverity.SUCCESS, "Creado",
                            "La categoria se guardo correctamente.");
                        this.close();
                        this.onChange.emit(c);
                    },
                    error => {
                        this.messageService.sendMsg(
                            MessageSeverity.ERROR,
                            "Error:",
                            "No se a podido guardar la categoria."
                        )
                    }
                );
        }
    }

    public validate() :boolean {
        if ( this.categoria.name != "" && this.categoria.name.length > 2) {
            this.isInvalid = false;
            return true;
        }else{
            this.isInvalid = true;
            return false;
        }
    }

    public close(){
        this.display = false;
        this.displayChange.emit(this.display);
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/dictamenes/categoria/categoria-form/categoria-form.component.ts